/* Bondel accessibility layer (keyboard + screen reader). Additive only:
   adds roles, tabindex, labels and Enter/Space support. Changes no visuals,
   no click handlers, no tracking. Remove this file + its include to roll back. */
(function () {
  'use strict';
  if (window.__bondelA11y) return;
  window.__bondelA11y = true;

  var NATIVE = /^(A|BUTTON|INPUT|SELECT|TEXTAREA|SUMMARY|LABEL|OPTION)$/;

  /* 1. Clickable divs (legacy Studio upload box, multi-pet slots, FAQ items, "let us choose" card) */
  var CLICKABLE = [
    '#uploadArea',
    '[onclick^="openMultiSlot"]',
    '.bondel-faq-item',
    '#bacAutoCard'
  ].join(',');

  function labelFor(el) {
    if (el.id === 'uploadArea') return 'Upload your pet photo';
    var m = (el.getAttribute('onclick') || '').match(/^openMultiSlot\((\d+)\)/);
    if (m) return 'Add photo ' + (Number(m[1]) + 1);
    return null;
  }

  function makeButton(el) {
    if (el.__a11yBtn || NATIVE.test(el.tagName)) return;
    el.__a11yBtn = true;
    if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    var lab = labelFor(el);
    if (lab && !el.hasAttribute('aria-label')) el.setAttribute('aria-label', lab);
    if (el.classList.contains('bondel-faq-item')) {
      el.setAttribute('aria-expanded', el.classList.contains('open') ? 'true' : 'false');
      new MutationObserver(function () {
        el.setAttribute('aria-expanded', el.classList.contains('open') ? 'true' : 'false');
      }).observe(el, { attributes: true, attributeFilter: ['class'] });
    }
    el.addEventListener('keydown', function (e) {
      if (e.target !== el) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        el.click();
      }
    });
  }

  /* 2. Product gallery: only the visible slide is a Tab stop (was 33 stops) */
  function fixGallery() {
    var photos = document.querySelectorAll('.product__slide .product__photo[tabindex]');
    for (var i = 0; i < photos.length; i++) {
      var slide = photos[i].closest('.product__slide');
      var hidden = slide && slide.classList.contains('media--hidden');
      var want = hidden ? '-1' : '0';
      if (photos[i].getAttribute('tabindex') !== want) photos[i].setAttribute('tabindex', want);
    }
    var thumbs = document.querySelectorAll('.product__thumb__link');
    for (var j = 0; j < thumbs.length; j++) {
      if (!thumbs[j].hasAttribute('aria-label') && !(thumbs[j].textContent || '').trim()) {
        thumbs[j].setAttribute('aria-label', 'Show image ' + (j + 1) + ' of ' + thumbs.length);
      }
    }
  }

  /* 3. Closed cart drawer should not be a Tab stop (still focusable by the theme when it opens) */
  function fixCartDrawer() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    var want = d.classList.contains('is-open') ? '0' : '-1';
    if (d.getAttribute('tabindex') !== want) d.setAttribute('tabindex', want);
  }

  /* 4. Missing names / alts */
  function fixNames() {
    var r = document.querySelectorAll('input.compare__input');
    for (var i = 0; i < r.length; i++) {
      if (!r[i].hasAttribute('aria-label')) r[i].setAttribute('aria-label', 'Drag to compare the original photo with the finished portrait');
    }
    var cmp = document.querySelectorAll('.compare');
    for (var c = 0; c < cmp.length; c++) {
      var base = cmp[c].querySelector('.compare__image:not(.compare__image--overlap) img:not([alt])');
      var over = cmp[c].querySelector('.compare__image--overlap img:not([alt])');
      if (base) base.setAttribute('alt', 'Original pet photo');
      if (over) over.setAttribute('alt', 'Finished painted portrait');
    }
    var imgs = document.querySelectorAll('img:not([alt])');
    for (var k = 0; k < imgs.length; k++) {
      var w = imgs[k].getAttribute('width');
      if (imgs[k].getAttribute('sizes') === '25px' || (w && Number(w) <= 60)) imgs[k].setAttribute('alt', '');
    }
  }

  /* 5. Page B style dialog: when it opens and focus is still behind it, move focus to its Close button */
  var dlgWasOpen = false;
  function fixDialogFocus() {
    var dlg = document.getElementById('bondelPageBDialog');
    if (!dlg) return;
    var open = !dlg.hidden && dlg.getClientRects().length > 0;
    if (open && !dlgWasOpen) {
      setTimeout(function () {
        try {
          if (dlg.hidden || dlg.contains(document.activeElement)) return;
          var close = dlg.querySelector('[data-page-b-close]');
          if (close && close.getClientRects().length) close.focus({ preventScroll: true });
        } catch (e) {}
      }, 350);
    }
    dlgWasOpen = open;
  }

  function run() {
    try {
      var els = document.querySelectorAll(CLICKABLE);
      for (var i = 0; i < els.length; i++) makeButton(els[i]);
      fixGallery();
      fixCartDrawer();
      fixNames();
      fixDialogFocus();
    } catch (e) { /* never break the page */ }
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; run(); }, 250);
  }

  function start() {
    run();
    try {
      new MutationObserver(schedule).observe(document.body, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden']
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
